(() => {
  const browsers = document.querySelectorAll('[data-location-browser]');

  browsers.forEach((browser) => {
    const input = browser.querySelector('[data-location-filter]');
    const links = [...browser.querySelectorAll('[data-location-link]')];
    const status = browser.querySelector('[data-location-status]');

    if (!input || links.length < 8) return;

    const update = () => {
      const query = input.value.trim().toLowerCase();
      let visible = 0;

      links.forEach((item) => {
        const matches = !query || item.textContent.toLowerCase().includes(query);
        item.hidden = !matches;
        if (matches) visible += 1;
      });

      if (status) {
        status.textContent = query ? `${visible} location${visible === 1 ? '' : 's'} found` : '';
      }
    };

    input.addEventListener('input', update);
  });

  document.querySelectorAll('[data-state-map]').forEach((map) => {
    const status = map.querySelector('[data-map-status]');
    const links = map.querySelectorAll('[data-map-state][href]');
    if (!status || !links.length) return;

    const label = status.querySelector('strong');
    const detail = status.querySelector('small');
    const defaultLabel = label?.textContent || '';
    const defaultDetail = detail?.textContent || '';

    const showState = (link) => {
      if (label) label.textContent = link.dataset.mapState || defaultLabel;
      if (detail) detail.textContent = link.dataset.mapClimate || 'View state guide';
    };

    const resetState = () => {
      if (label) label.textContent = defaultLabel;
      if (detail) detail.textContent = defaultDetail;
    };

    links.forEach((link) => {
      link.addEventListener('pointerenter', () => showState(link));
      link.addEventListener('pointerleave', resetState);
      link.addEventListener('focus', () => showState(link));
      link.addEventListener('blur', resetState);
    });
  });
})();
